import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from './tooltip.directive';
import { TooltipComponent } from './tooltip.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    TooltipDirective,
    TooltipComponent
  ],
  imports: [
    CommonModule, TranslateModule.forChild()
  ],
  exports:[TooltipDirective]
})
export class TooltipModule { }
